import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import sliderImage1 from "../assets/images/slider1.avif";
import sliderImage2 from "../assets/images/slider2.avif";
import sliderImage3 from "../assets/images/slider3.avif";
import sliderImage4 from "../assets/images/slider.avif";

const Hero = () => {
  const slides = [sliderImage1, sliderImage2, sliderImage3, sliderImage4];
  const rotatingMessages = [
    "Dream • Discover • Excel",
    "Building Future Leaders Today",
    "A Lifetime of Learning Starts Here",
    "Empowering Minds, Shaping Futures",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
      setCurrentMessageIndex((prevMessageIndex) => (prevMessageIndex + 1) % rotatingMessages.length);
    }, 5000);

    return () => clearInterval(slideInterval);
  }, [slides.length, rotatingMessages.length]);

  return (
    <div className="h-[700px] pt-40 relative text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
      {/* Slider */}
      <AnimatePresence>
        {slides.map((slide, index) =>
          index === currentIndex ? (
            <motion.div
              key={index}
              className="absolute inset-0 bg-cover bg-center w-full h-full"
              style={{ backgroundImage: `url(${slide})` }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
            />
          ) : null
        )}
      </AnimatePresence>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative flex flex-col md:flex-row justify-between items-center h-full text-center md:text-left px-6">
        {/* Left Content */}
        <div className="md:flex-1 flex flex-col items-center md:items-start">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-thin mb-4 drop-shadow-lg text-purple-400" style={{ fontFamily: "'Pacifico', cursive" }}>
            Welcome to
          </h1>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-light mb-4 drop-shadow-lg text-yellow-300" style={{ fontFamily: "'Caveat', cursive" }}>
            Joy Gardens School
          </h1>
        </div>

        {/* Right Content - Enroll Section */}
        <div className="md:flex-1 flex justify-center items-center relative">
          <motion.div
            className="relative p-6 md:p-8 bg-white bg-opacity-80 text-purple-900 rounded-[50%] shadow-lg flex flex-col justify-center items-center border-4 border-yellow-400"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.9 }}
            transition={{ duration: 1.5 }}
          >
            <motion.p
              key={currentMessageIndex}
              className="text-lg sm:text-xl font-semibold mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.8 }}
            >
              {rotatingMessages[currentMessageIndex]}
            </motion.p>
            <a
              href="/contact"
              className="bg-yellow-400 text-purple-900 px-6 py-2 sm:px-8 sm:py-3 rounded-full font-medium text-sm sm:text-lg shadow-lg hover:bg-yellow-500 transition-transform transform hover:scale-105"
            >
              Enroll Today
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
